/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePurchaseInvoicePositionDto
 */
export interface CreateUpdatePurchaseInvoicePositionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoicePositionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoicePositionDto
     */
    netAmount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoicePositionDto
     */
    vat: CreateUpdatePurchaseInvoicePositionDtoVatEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoicePositionDto
     */
    vatAmount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoicePositionDto
     */
    purchaseInvoiceId: string;
}


/**
 * @export
 */
export const CreateUpdatePurchaseInvoicePositionDtoVatEnum = {
    _23: '23%',
    _19: '19%',
    _8: '8%',
    _5: '5%',
    _4: '4%',
    _0: '0%',
    Zw: 'zw.',
    Np: 'np.'
} as const;
export type CreateUpdatePurchaseInvoicePositionDtoVatEnum = typeof CreateUpdatePurchaseInvoicePositionDtoVatEnum[keyof typeof CreateUpdatePurchaseInvoicePositionDtoVatEnum];


/**
 * Check if a given object implements the CreateUpdatePurchaseInvoicePositionDto interface.
 */
export function instanceOfCreateUpdatePurchaseInvoicePositionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "netAmount" in value;
    isInstance = isInstance && "vat" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "purchaseInvoiceId" in value;

    return isInstance;
}

export function CreateUpdatePurchaseInvoicePositionDtoFromJSON(json: any): CreateUpdatePurchaseInvoicePositionDto {
    return CreateUpdatePurchaseInvoicePositionDtoFromJSONTyped(json, false);
}

export function CreateUpdatePurchaseInvoicePositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePurchaseInvoicePositionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'netAmount': json['netAmount'],
        'vat': json['vat'],
        'vatAmount': json['vatAmount'],
        'purchaseInvoiceId': json['purchaseInvoiceId'],
    };
}

export function CreateUpdatePurchaseInvoicePositionDtoToJSON(value?: CreateUpdatePurchaseInvoicePositionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'netAmount': value.netAmount,
        'vat': value.vat,
        'vatAmount': value.vatAmount,
        'purchaseInvoiceId': value.purchaseInvoiceId,
    };
}

